import React from 'react';
import EcoClass92023 from 'views/EcoClass92023';

const AccountGeneralPage = () => {
  return <EcoClass92023/>;
};

export default AccountGeneralPage;
